import { render } from "./CustomersFeedbackWeek.vue?vue&type=template&id=6f579618&ts=true"
import script from "./CustomersFeedbackWeek.vue?vue&type=script&lang=ts"
export * from "./CustomersFeedbackWeek.vue?vue&type=script&lang=ts"

import "./CustomersFeedbackWeek.vue?vue&type=style&index=0&id=6f579618&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__